// -1 自己 1=衢州人才网 2=
export const valley_id = 1
export const hrefs = {
  ats: 'http://ats.qzrcw.com/login/',
  cfts: 'http://cfts.jialeijob.com/login'
}

export const headerList = [
  {
    text: "首页", link: "/home"
  },
  {
    text: "找工作", link: "/jobs"
  },
  {
    text: "找企业", link: "/company"
  },
  {
    text: "找人才", link: "/resume"
  },
  {
    text: "看资讯", link: "/information"
  },
  {
    text: "看活动", link: "/activity"
  },
  {
    text: "报考试", link: "/examination"
  },
]

export const activityCate = [
  {
    label: "全部活动", value: ""
  },
  // {
  //   label: "正在进行", value: ""
  // },
  // {
  //   label: "往期精彩", value: ""
  // }
]
export const examinationCate = [
  {
    label: "全部考试", value: ""
  },
  // {
  //   label: "正在进行", value: ""
  // },
  // {
  //   label: "往期精彩", value: ""
  // }
]
export const jobsCate = [
  {
    label: "全部职位", value: ""
  },
  // {
  //   label: "热门职位", value: "hot"
  // }, 
  {
    label: "近期发布", value: "recent"
  }
]
export const specialCfCate = [
  {
    label: "热招职位", value: ""
  },
  // {
  //   label: "热门职位", value: "hot"
  // }, 
  {
    label: "参会企业", value: "recent"
  }
]
export const companyCate = [
  {
    label: "全部公司", value: ""
  },
  // {
  //   label: "热门", value: "hot"
  // },
]

export const personalCate = [
  {
    label: "全部人才", value: ""
  },
]

export const informationCate = [
  {
    label: "公共服务", value: "2"
  },
  {
    label: "国企招聘", value: "1"
  }
]
export const companyDetailNavList = [
  {
    label:"公司介绍"
  },{
    label:"招聘职位"
  }
]

export const activityDetailNavList = [
  {
    label:"活动详情"
  },{
    label:"参会企业"
  },{
    label:"热招职位"
  }
]

export const examinationDetailNavList = [
  {
    label:"企业"
  },
  {
    label:"岗位"
  }
]

// 首页的数字
export const homeNums = [
  {
    url: require("assets/company_num.png")
  },
  {
    url: require("assets/job_num.png")
  },
  {
    url: require("assets/people_num.png")
  }
]
// bannerseiper
export const bannerList = [
  {
    url: require("assets/banner.png")
  }
]

export const resumeData={
  jobHuntingStatusOptions:[{label:'在校-想找实习',value:1},{label:'在校-想找全职',value:2},{label:'离职-随时到岗',value:3},{label:'在职-月内到岗',value:4},{label:'在职-考虑机会',value:5},{label:'在职-暂不考虑',value:6}],
  degrees:["初中","中专","高中","大专","本科","硕士","博士"],
  workType:[{label:'全职',value:1},{label:'兼职',value:2},{label:'实习',value:3}]
}




// 工资单位
export const salaryUnit = {
  '1': '元/时',
  '2': '元/天',
  '3': '元/月',
  '4': '元/年'
}

// 行业
export const mainIndustryData = [
  "",
  "互联网/IT/电子/通信",
  "区块链",
  "广告/传媒/文化/体育",
  "金融",
  "教育培训",
  "制药/医疗",
  "交通/物流/贸易/零售",
  "专业服务",
  "汽车",
  "机械/制造",
  "消费品",
  "服务业",
  "能源/化工/环保",
  "房地产/建筑",
  "政府/非盈利/其他"
]
export const jobSalaryType = { 1: '/时', 2: '/天', 3: '/月', 4: '/年', 0: '面议' }
// 工作经验
export const experience = [
  {
    value: "",
    label: "不限"
  },
  {
    value: "<1年",
    label: "<1年"
  },
  {
    value: "1-3年",
    label: "1-3年"
  },
  {
    value: "3-5年",
    label: "3-5年"
  },
  {
    value: "5-10年",
    label: "5-10年"
  },
  {
    value: ">10年",
    label: ">10年"
  }
]
//年龄筛选
export const ages = [
  {
    value: "",
    label: "不限"
  },
  {
    value: "18-24岁",
    label: "18-24岁"
  },
  {
    value: "25-30岁",
    label: "25-30岁"
  },
  {
    value: "31-40岁",
    label: "31-40岁"
  },
  {
    value: "40岁以上",
    label: "40岁以上"
  }
]

// 学历
export const education = [
  {
    value: "",
    label: "不限"
  },
  {
    value: "中专/高中",
    label: "中专/高中"
  },
  {
    value: "大专",
    label: "大专"
  },
  {
    value: "本科",
    label: "本科"
  },
  {
    value: "硕士",
    label: "硕士"
  },
  {
    value: "博士",
    label: "博士"
  }
]

// 薪资
export const salary = [
  {
    value: '',
    label: '不限'
  },
  {
    value: '3k以下',
    label: '3k以下'
  },
  {
    value: '3-5k',
    label: '3-5k'
  },
  {
    value: '5-10k',
    label: '5-10k'
  },
  {
    value: '10-15k',
    label: '10-15k'
  },
  {
    value: '15-20k',
    label: '15-20k'
  },
  {
    value: '20-30k',
    label: '20-30k'
  },
  {
    value: '30-50k',
    label: '30-50k'
  },
  {
    value: '50k以上',
    label: '50k以上'
  }
]

// 发布时间
export const publish_time = [
  {
    value: '',
    label: '不限'
  },
  {
    value: '一天以内',
    label: '一天以内'
  },
  {
    value: '三天以内',
    label: '三天以内'
  },
  {
    value: '七天以内',
    label: '七天以内'
  },
  {
    value: '十五天以内',
    label: '十五天以内'
  },
  {
    value: '一个月以内',
    label: '一个月以内'
  }
]

export const wxCity = ['柯城区', '衢江区', '江山市', '龙游县', '常山县', '开化县','鞍山', '阿拉善盟', '安康', '阿克苏地区', '阿勒泰地区', '阿拉尔', '安阳', '安庆', '安顺', '阿里地区', '澳门','北京', '白城', '白山', '本溪', '包头', '巴彦淖尔', '保定', '宝鸡', '滨州', '巴音郭楞蒙古自治州', '博尔塔拉蒙古自治州', '北屯市', '白银', '蚌埠', '亳州', '毕节', '巴中', '保山', '百色', '北海', '白沙黎族自治县', '保亭黎族苗族自治县','重庆', '长春', '朝阳', '赤峰', '承德', '沧州', '长治', '昌吉回族自治州', '常州', '滁州', '池州', '长沙', '郴州', '常德', '成都', '潮州', '楚雄彝族自治州', '崇左', '澄迈', '昌江黎族自治县', '昌都','大庆', '大兴安岭地区', '大连', '丹东', '大同', '德州', '东营', '定西', '达州', '德阳', '东莞', '东沙群岛', '德宏傣族景颇族自治州', '迪庆藏族自治州', '大理白族自治州', '儋州', '东方', '定安','鄂尔多斯', '鄂州', '恩施土家族苗族自治州', '阿坝藏族羌族自治州','果洛藏族自治州', '甘南藏族自治州', '固原', '赣州', '贵阳', '广安', '广元', '甘孜藏族自治州', '广州', '桂林', '贵港','抚顺', '阜新', '阜阳', '福州', '抚州', '佛山', '防城港','哈尔滨', '黑河', '鹤岗', '葫芦岛', '呼和浩特', '呼伦贝尔', '衡水', '邯郸', '汉中', '菏泽', '哈密', '和田地区', '海东', '海北藏族自治州', '黄南藏族自治州', '海南藏族自治州', '海西蒙古族藏族自治州', '鹤壁', '淮安', '黄冈', '黄石', '杭州', '湖州', '合肥', '淮南', '淮北', '黄山', '衡阳', '怀化', '惠州', '河源', '红河哈尼族彝族自治州', '贺州', '河池', '海口','佳木斯', '鸡西', '吉林', '锦州', '晋中', '晋城', '济南', '济宁', '金昌', '酒泉', '嘉峪关', '焦作', '济源', '荆州', '荆门', '嘉兴', '金华', '九江', '吉安', '景德镇', '江门', '揭阳','克拉玛依', '克孜勒苏柯尔克孜自治州', '喀什地区', '可克达拉市', '昆玉市', '开封', '昆明','辽源', '辽阳', '廊坊', '临汾', '吕梁', '临沂', '聊城', '兰州', '陇南', '临夏回族自治州', '洛阳', '漯河', '连云港', '丽水', '六安', '龙岩', '娄底', '六盘水', '泸州', '乐山', '凉山彝族自治州', '临沧', '丽江', '柳州', '来宾', '临高', '乐东黎族自治县', '陵水黎族自治县', '拉萨', '林芝','牡丹江', '马鞍山', '绵阳', '眉山', '梅州', '茂名','南阳', '南京', '南通', '宁波', '宁德', ' 南平', '南昌', '南充', '内江', '怒江傈僳族自治州', '南宁', '那曲','齐齐哈尔', '七台河', ' 秦皇岛', '青岛', '庆阳', '潜江', '衢州', '泉州', '黔东南苗族侗族自治州', '黔南布依族苗族自治州', '黔西南布依族苗族自治州', '清远', '曲靖', '钦州', '琼海', '琼中黎族苗族自治县','日照', '日喀则','盘锦', '平凉', '平顶山', '濮阳', '莆田', '萍乡', '攀枝花', '普洱','上海', '绥化', '双鸭山', '四平', '松原', '沈阳', '石家庄', '朔州', '商洛', '石河子', '双河市', '石嘴山', '商丘', '三门峡', '苏州', '宿迁', '十堰', '随州', '神农架', '绍兴', '宿州', '三明', '上饶', '邵阳', '遂宁', '韶关', '汕头', '深圳', '汕尾', '三亚', '三沙', '山南','天津', '通化', '铁岭', '通辽', '唐山', '太原', '铜川', '泰安', '吐鲁番', '塔城地区', '图 木舒克', '铁门关', '天水', '泰州', '天门', '台州', '铜陵', '铜仁', '屯昌', '台湾','乌海', '乌兰察布', '渭南', '潍坊', '威海', '乌鲁木齐', '五家渠', '武威', '吴忠', '无锡', '武汉', '温 州', '芜湖', '文山壮族苗族自治州', '梧州', '五指山', '文昌', '万宁','锡林郭勒盟', '兴安盟', '邢台', '忻州', '西安', '咸阳', '西宁', '新乡', '许昌', '信阳', '徐州', '襄阳', '孝感', '咸 宁', '仙桃', '宣城', '厦门', '新余', '湘潭', '湘西土家族苗族自治州', '西双版纳傣族自治州', '香港','伊春', '延边朝鲜族自治州', '营口', '阳泉', '运城', '延安', '榆林', '烟台', '伊犁哈萨 克自治州', '玉树藏族自治州', '银川', '扬州', '盐城', '宜昌', '宜春', '鹰潭', '益阳', '岳阳', '永州', '宜宾', '雅安', '云浮', '阳江', '玉溪', '玉林','张家口', '淄博', '枣庄', '张掖', ' 中卫', '郑州', '周口', '驻马店', '镇江', '舟山', '漳州', '株洲', '张家界', '遵义', '自贡', '资阳', '珠海', '肇庆', '湛江', '中山', '昭通']

export const politicsStatus = [
  {
    label:"中共党员",
    value:"中共党员",
  },
  {
    label:"中共预备党员",
    value:"中共预备党员",
  },
  {
    label:"共青团员",
    value:"共青团员",
  },
  {
    label:"民革会员",
    value:"民革会员",
  },
  {
    label:"民盟盟员",
    value:"民盟盟员",
  },
  {
    label:"民建会员",
    value:"民建会员",
  },
  {
    label:"民进会员",
    value:"民进会员",
  },
  {
    label:"农工党党员",
    value:"农工党党员",
  },
  {
    label:"致公党党员",
    value:"致公党党员",
  },
  {
    label:"九三学社社员",
    value:"九三学社社员",
  },
  {
    label:"台盟盟员",
    value:"台盟盟员",
  },
  {
    label:"无党派人士",
    value:"无党派人士",
  },
  {
    label:"群众",
    value:"群众",
  },
]

export const category = [{"label":"技术","value":"技术","children":[{"label":"后端开发","value":"后端开发","children":[{"label":"Java","value":"Java"},{"label":"C++","value":"C++"},{"label":"PHP","value":"PHP"},{"label":"C","value":"C"},{"label":"C#","value":"C#"},{"label":".NET","value":".NET"},{"label":"Hadoop","value":"Hadoop"},{"label":"Python","value":"Python"},{"label":"Delphi","value":"Delphi"},{"label":"VB","value":"VB"},{"label":"Perl","value":"Perl"},{"label":"Ruby","value":"Ruby"},{"label":"Node.js","value":"Node.js"},{"label":"Golang","value":"Golang"},{"label":"Erlang","value":"Erlang"},{"label":"语音/视频/图形开发","value":"语音/视频/图形开发"},{"label":"数据采集","value":"数据采集"},{"label":"全栈工程师","value":"全栈工程师"},{"label":"GIS工程师","value":"GIS工程师"}]},{"label":"移动开发","value":"移动开发","children":[{"label":"HTML5","value":"HTML5"},{"label":"Android","value":"Android"},{"label":"iOS","value":"iOS"},{"label":"移动web前端","value":"移动web前端"},{"label":"Flash开发","value":"Flash开发"},{"label":"JavaScript","value":"JavaScript"},{"label":"U3D","value":"U3D"},{"label":"COCOS2DX","value":"COCOS2DX"},{"label":"UE4","value":"UE4"}]},{"label":"测试","value":"测试","children":[{"label":"测试工程师","value":"测试工程师"},{"label":"自动化测试","value":"自动化测试"},{"label":"功能测试","value":"功能测试"},{"label":"性能测试","value":"性能测试"},{"label":"测试开发","value":"测试开发"},{"label":"移动端测试","value":"移动端测试"},{"label":"游戏测试","value":"游戏测试"},{"label":"硬件测试","value":"硬件测试"},{"label":"软件测试","value":"软件测试"},{"label":"渗透测试","value":"渗透测试"}]},{"label":"运维/技术支持","value":"运维/技术支持","children":[{"label":"运维工程师","value":"运维工程师"},{"label":"运维开发工程师","value":"运维开发工程师"},{"label":"网络工程师","value":"网络工程师"},{"label":"系统工程师","value":"系统工程师"},{"label":"IT技术支持","value":"IT技术支持"},{"label":"系统管理员","value":"系统管理员"},{"label":"网络安全","value":"网络安全"},{"label":"系统安全","value":"系统安全"},{"label":"DBA","value":"DBA"}]},{"label":"数据","value":"数据","children":[{"label":"ETL工程师","value":"ETL工程师"},{"label":"数据仓库","value":"数据仓库"},{"label":"数据开发","value":"数据开发"},{"label":"数据挖掘","value":"数据挖掘"},{"label":"数据分析师","value":"数据分析师"},{"label":"数据架构师","value":"数据架构师"}]},{"label":"项目管理","value":"项目管理","children":[{"label":"项目经理","value":"项目经理"},{"label":"项目主管","value":"项目主管"},{"label":"项目助理","value":"项目助理"},{"label":"项目专员","value":"项目专员"},{"label":"实施顾问","value":"实施顾问"},{"label":"实施工程师","value":"实施工程师"},{"label":"需求分析工程师","value":"需求分析工程师"},{"label":"硬件项目经理","value":"硬件项目经理"}]},{"label":"硬件开发","value":"硬件开发","children":[{"label":"硬件工程师","value":"硬件工程师"},{"label":"嵌入式","value":"嵌入式"},{"label":"自动化","value":"自动化"},{"label":"单片机","value":"单片机"},{"label":"电路设计","value":"电路设计"},{"label":"驱动开发","value":"驱动开发"},{"label":"系统集成","value":"系统集成"},{"label":"FPGA开发","value":"FPGA开发"},{"label":"DSP开发","value":"DSP开发"},{"label":"ARM开发","value":"ARM开发"},{"label":"PCB工艺","value":"PCB工艺"},{"label":"射频工程师","value":"射频工程师"}]},{"label":"前端开发","value":"前端开发","children":[{"label":"web前端","value":"web前端"},{"label":"JavaScript","value":"JavaScript"},{"label":"Flash开发","value":"Flash开发"},{"label":"HTML5","value":"HTML5"}]},{"label":"通信","value":"通信","children":[{"label":"通信技术工程师","value":"通信技术工程师"},{"label":"通信研发工程师","value":"通信研发工程师"},{"label":"数据通信工程师","value":"数据通信工程师"},{"label":"移动通信工程师","value":"移动通信工程师"},{"label":"电信网络工程师","value":"电信网络工程师"},{"label":"电信交换工程师","value":"电信交换工程师"},{"label":"有线传输工程师","value":"有线传输工程师"},{"label":"无线/射频通信工程师","value":"无线/射频通信工程师"},{"label":"通信电源工程师","value":"通信电源工程师"},{"label":"通信标准化工程师","value":"通信标准化工程师"},{"label":"通信项目专员","value":"通信项目专员"},{"label":"通信项目经理","value":"通信项目经理"},{"label":"核心网工程师","value":"核心网工程师"},{"label":"通信测试工程师","value":"通信测试工程师"},{"label":"通信设备工程师","value":"通信设备工程师"},{"label":"光通信工程师","value":"光通信工程师"},{"label":"光传输工程师","value":"光传输工程师"},{"label":"光网络工程师","value":"光网络工程师"}]},{"label":"电子/半导体","value":"电子/半导体","children":[{"label":"电气工程师","value":"电气工程师"},{"label":"电气设计工程师","value":"电气设计工程师"},{"label":"电子工程师","value":"电子工程师"},{"label":"集成电路IC设计","value":"集成电路IC设计"},{"label":"FAE","value":"FAE"},{"label":"IC验证工程师","value":"IC验证工程师"}]},{"label":"高端技术职位","value":"高端技术职位","children":[{"label":"技术经理","value":"技术经理"},{"label":"技术总监","value":"技术总监"},{"label":"测试经理","value":"测试经理"},{"label":"架构师","value":"架构师"},{"label":"CTO","value":"CTO"},{"label":"运维总监","value":"运维总监"},{"label":"技术合伙人","value":"技术合伙人"}]},{"label":"人工智能","value":"人工智能","children":[{"label":"数据挖掘","value":"数据挖掘"},{"label":"搜索算法","value":"搜索算法"},{"label":"自然语言处理","value":"自然语言处理"},{"label":"推荐算法","value":"推荐算法"},{"label":"算法工程师","value":"算法工程师"},{"label":"智能驾驶系统工程师","value":"智能驾驶系统工程师"},{"label":"反欺诈/风控算法","value":"反欺诈/风控算法"},{"label":"机器学习","value":"机器学习"},{"label":"深度学习","value":"深度学习"},{"label":"语音识别","value":"语音识别"},{"label":"图像识别","value":"图像识别"},{"label":"算法研究员","value":"算法研究员"}]},{"label":"销售技术支持","value":"销售技术支持","children":[{"label":"售前技术支持","value":"售前技术支持"},{"label":"售后技术支持","value":"售后技术支持"}]},{"label":"其他技术职位","value":"其他技术职位","children":[{"label":"其他技术职位","value":"其他技术职位"}]}]},{"label":"运营","value":"运营","children":[{"label":"运营","value":"运营","children":[{"label":"用户运营","value":"用户运营"},{"label":"产品运营","value":"产品运营"},{"label":"数据运营","value":"数据运营"},{"label":"内容运营","value":"内容运营"},{"label":"活动运营","value":"活动运营"},{"label":"商家运营","value":"商家运营"},{"label":"品类运营","value":"品类运营"},{"label":"游戏运营","value":"游戏运营"},{"label":"网站运营","value":"网站运营"},{"label":"新媒体运营","value":"新媒体运营"},{"label":"社区运营","value":"社区运营"},{"label":"微信运营","value":"微信运营"},{"label":"微博运营","value":"微博运营"},{"label":"策略运营","value":"策略运营"},{"label":"线下拓展运营","value":"线下拓展运营"},{"label":"电商运营","value":"电商运营"},{"label":"运营助理/专员","value":"运营助理/专员"},{"label":"内容审核","value":"内容审核"},{"label":"数据标注","value":"数据标注"},{"label":"直播运营","value":"直播运营"},{"label":"车辆运营","value":"车辆运营"},{"label":"跨境电商运营","value":"跨境电商运营"},{"label":"网店店长","value":"网店店长"}]},{"label":"编辑","value":"编辑","children":[{"label":"副主编","value":"副主编"},{"label":"内容编辑","value":"内容编辑"},{"label":"文案策划","value":"文案策划"},{"label":"网站编辑","value":"网站编辑"},{"label":"采编","value":"采编"},{"label":"医学编辑","value":"医学编辑"}]},{"label":"客服","value":"客服","children":[{"label":"售前客服","value":"售前客服"},{"label":"售后客服","value":"售后客服"},{"label":"网络客服","value":"网络客服"},{"label":"客服经理","value":"客服经理"},{"label":"客服专员","value":"客服专员"},{"label":"客服主管","value":"客服主管"},{"label":"电话客服","value":"电话客服"},{"label":"咨询热线/呼叫中心客服","value":"咨询热线/呼叫中心客服"}]},{"label":"高端运营职位","value":"高端运营职位","children":[{"label":"主编","value":"主编"},{"label":"运营总监","value":"运营总监"},{"label":"COO","value":"COO"},{"label":"客服总监","value":"客服总监"},{"label":"运营经理/主管","value":"运营经理/主管"}]},{"label":"其他运营职位","value":"其他运营职位","children":[{"label":"其他运营职位","value":"其他运营职位"}]}]},{"label":"销售","value":"销售","children":[{"label":"销售行政/商务","value":"销售行政/商务","children":[{"label":"商务专员","value":"商务专员"},{"label":"商务经理","value":"商务经理"},{"label":"销售助理","value":"销售助理"},{"label":"商务总监","value":"商务总监"},{"label":"销售运营","value":"销售运营"}]},{"label":"房地产销售/招商","value":"房地产销售/招商","children":[{"label":"置业顾问","value":"置业顾问"},{"label":"地产中介","value":"地产中介"},{"label":"物业招商管理","value":"物业招商管理"},{"label":"房地产销售总监","value":"房地产销售总监"}]},{"label":"服务业销售","value":"服务业销售","children":[{"label":"彩妆顾问","value":"彩妆顾问"},{"label":"美容顾问","value":"美容顾问"},{"label":"会籍顾问","value":"会籍顾问"},{"label":"珠宝销售","value":"珠宝销售"},{"label":"旅游顾问","value":"旅游顾问"},{"label":"瘦身顾问","value":"瘦身顾问"}]},{"label":"汽车销售","value":"汽车销售","children":[{"label":"汽车销售","value":"汽车销售"},{"label":"汽车配件销售","value":"汽车配件销售"}]},{"label":"广告/会展销售","value":"广告/会展销售","children":[{"label":"广告销售","value":"广告销售"},{"label":"会议活动销售","value":"会议活动销售"},{"label":"会展活动销售","value":"会展活动销售"},{"label":"媒介顾问","value":"媒介顾问"}]},{"label":"金融销售","value":"金融销售","children":[{"label":"证券经纪人","value":"证券经纪人"},{"label":"信用卡销售","value":"信用卡销售"},{"label":"保险顾问","value":"保险顾问"},{"label":"理财顾问","value":"理财顾问"}]},{"label":"外贸销售","value":"外贸销售","children":[{"label":"外贸经理","value":"外贸经理"},{"label":"外贸业务员","value":"外贸业务员"}]},{"label":"销售","value":"销售","children":[{"label":"销售专员","value":"销售专员"},{"label":"客户代表","value":"客户代表"},{"label":"大客户代表","value":"大客户代表"},{"label":"BD经理","value":"BD经理"},{"label":"渠道销售","value":"渠道销售"},{"label":"代理商销售","value":"代理商销售"},{"label":"电话销售","value":"电话销售"},{"label":"销售顾问","value":"销售顾问"},{"label":"网络销售","value":"网络销售"},{"label":"销售工程师","value":"销售工程师"},{"label":"客户经理","value":"客户经理"}]},{"label":"课程销售","value":"课程销售","children":[{"label":"课程顾问","value":"课程顾问"},{"label":"招生顾问","value":"招生顾问"},{"label":"留学顾问","value":"留学顾问"}]},{"label":"医疗销售","value":"医疗销售","children":[{"label":"医疗器械销售","value":"医疗器械销售"},{"label":"医药代表","value":"医药代表"},{"label":"健康顾问","value":"健康顾问"},{"label":"医美咨询","value":"医美咨询"}]},{"label":"销售管理","value":"销售管理","children":[{"label":"销售经理","value":"销售经理"},{"label":"销售总监","value":"销售总监"},{"label":"区域总监","value":"区域总监"},{"label":"城市经理","value":"城市经理"},{"label":"销售VP","value":"销售VP"},{"label":"团队经理","value":"团队经理"}]},{"label":"其他销售职位","value":"其他销售职位","children":[{"label":"其他销售职位","value":"其他销售职位"}]}]},{"label":"人事/财务/行政","value":"人事/财务/行政","children":[{"label":"人力资源","value":"人力资源","children":[{"label":"人力资源主管","value":"人力资源主管"},{"label":"招聘","value":"招聘"},{"label":"HRBP","value":"HRBP"},{"label":"人力资源专员/助理","value":"人力资源专员/助理"},{"label":"培训","value":"培训"},{"label":"薪资福利","value":"薪资福利"},{"label":"绩效考核","value":"绩效考核"},{"label":"人力资源经理","value":"人力资源经理"},{"label":"人力资源VP/CHO","value":"人力资源VP/CHO"},{"label":"人力资源总监","value":"人力资源总监"},{"label":"员工关系","value":"员工关系"},{"label":"组织发展","value":"组织发展"}]},{"label":"行政","value":"行政","children":[{"label":"行政专员/助理","value":"行政专员/助理"},{"label":"前台","value":"前台"},{"label":"行政主管","value":"行政主管"},{"label":"经理助理","value":"经理助理"},{"label":"后勤","value":"后勤"},{"label":"行政经理","value":"行政经理"},{"label":"行政总监","value":"行政总监"}]},{"label":"财务","value":"财务","children":[{"label":"会计","value":"会计"},{"label":"出纳","value":"出纳"},{"label":"财务顾问","value":"财务顾问"},{"label":"结算","value":"结算"},{"label":"税务","value":"税务"},{"label":"审计","value":"审计"},{"label":"风控","value":"风控"},{"label":"成本","value":"成本"},{"label":"总账会计","value":"总账会计"},{"label":"财务经理","value":"财务经理"},{"label":"CFO","value":"CFO"},{"label":"财务总监","value":"财务总监"},{"label":"财务主管","value":"财务主管"}]},{"label":"法务","value":"法务","children":[{"label":"法务专员/助理","value":"法务专员/助理"},{"label":"律师","value":"律师"},{"label":"法律顾问","value":"法律顾问"},{"label":"法务主管","value":"法务主管"},{"label":"法务经理","value":"法务经理"},{"label":"法务总监","value":"法务总监"}]},{"label":"其他职能职位","value":"其他职能职位","children":[{"label":"其他职能职位","value":"其他职能职位"}]}]},{"label":"高级管理","value":"高级管理","children":[{"label":"高级管理职位","value":"高级管理职位","children":[{"label":"总裁/总经理/CEO","value":"总裁/总经理/CEO"},{"label":"副总裁/副总经理/VP","value":"副总裁/副总经理/VP"},{"label":"分公司/代表处负责人","value":"分公司/代表处负责人"},{"label":"区域负责人(辖多个分公司)","value":"区域负责人(辖多个分公司)"},{"label":"总助/CEO助理/董事长助理","value":"总助/CEO助理/董事长助理"},{"label":"合伙人","value":"合伙人"},{"label":"联合创始人","value":"联合创始人"},{"label":"董事会秘书","value":"董事会秘书"}]}]},{"label":"设计","value":"设计","children":[{"label":"视觉/交互设计","value":"视觉/交互设计","children":[{"label":"视觉设计师","value":"视觉设计师"},{"label":"网页设计师","value":"网页设计师"},{"label":"Flash设计师","value":"Flash设计师"},{"label":"APP设计师","value":"APP设计师"},{"label":"UI设计师","value":"UI设计师"},{"label":"平面设计","value":"平面设计"},{"label":"3D设计师","value":"3D设计师"},{"label":"广告设计","value":"广告设计"},{"label":"多媒体设计师","value":"多媒体设计师"},{"label":"原画师","value":"原画师"},{"label":"CAD设计/制图","value":"CAD设计/制图"},{"label":"美工","value":"美工"},{"label":"包装设计","value":"包装设计"},{"label":"设计师助理","value":"设计师助理"},{"label":"动画设计","value":"动画设计"},{"label":"插画师","value":"插画师"},{"label":"漫画师","value":"漫画师"},{"label":"人像修图师","value":"人像修图师"},{"label":"交互设计师","value":"交互设计师"}]},{"label":"游戏设计","value":"游戏设计","children":[{"label":"游戏特效","value":"游戏特效"},{"label":"游戏界面设计师","value":"游戏界面设计师"},{"label":"游戏场景","value":"游戏场景"},{"label":"游戏角色","value":"游戏角色"},{"label":"游戏动作","value":"游戏动作"},{"label":"游戏数值策划","value":"游戏数值策划"}]},{"label":"用户研究","value":"用户研究","children":[{"label":"数据分析师","value":"数据分析师"},{"label":"用户研究员","value":"用户研究员"},{"label":"UX设计师","value":"UX设计师"},{"label":"用户研究经理","value":"用户研究经理"},{"label":"用户研究总监","value":"用户研究总监"}]},{"label":"高端设计职位","value":"高端设计职位","children":[{"label":"设计经理/主管","value":"设计经理/主管"},{"label":"设计总监","value":"设计总监"},{"label":"视觉设计总监","value":"视觉设计总监"}]},{"label":"非视觉设计","value":"非视觉设计","children":[{"label":"展览/展示设计","value":"展览/展示设计"},{"label":"照明设计","value":"照明设计"},{"label":"服装/纺织设计","value":"服装/纺织设计"},{"label":"工业设计","value":"工业设计"},{"label":"橱柜设计","value":"橱柜设计"},{"label":"家具设计","value":"家具设计"},{"label":"家居设计","value":"家居设计"},{"label":"珠宝设计","value":"珠宝设计"},{"label":"室内设计","value":"室内设计"},{"label":"陈列设计","value":"陈列设计"}]},{"label":"其他设计职位","value":"其他设计职位","children":[{"label":"其他设计职位","value":"其他设计职位"}]}]},{"label":"市场","value":"市场","children":[{"label":"政府事务","value":"政府事务","children":[{"label":"政府关系","value":"政府关系"},{"label":"政策研究","value":"政策研究"},{"label":"企业党建","value":"企业党建"}]},{"label":"市场/营销","value":"市场/营销","children":[{"label":"网络推广","value":"网络推广"},{"label":"市场营销","value":"市场营销"},{"label":"市场策划","value":"市场策划"},{"label":"市场顾问","value":"市场顾问"},{"label":"市场推广","value":"市场推广"},{"label":"SEO","value":"SEO"},{"label":"SEM","value":"SEM"},{"label":"商务渠道","value":"商务渠道"},{"label":"商业数据分析","value":"商业数据分析"},{"label":"活动策划","value":"活动策划"},{"label":"网络营销","value":"网络营销"},{"label":"海外市场","value":"海外市场"},{"label":"APP推广","value":"APP推广"},{"label":"选址开发","value":"选址开发"},{"label":"游戏推广","value":"游戏推广"},{"label":"营销主管","value":"营销主管"}]},{"label":"公关媒介","value":"公关媒介","children":[{"label":"媒介经理","value":"媒介经理"},{"label":"广告协调","value":"广告协调"},{"label":"品牌公关","value":"品牌公关"},{"label":"媒介专员","value":"媒介专员"},{"label":"活动策划执行","value":"活动策划执行"},{"label":"媒介策划","value":"媒介策划"}]},{"label":"会务会展","value":"会务会展","children":[{"label":"会议活动策划","value":"会议活动策划"},{"label":"会议活动执行","value":"会议活动执行"},{"label":"会展活动策划","value":"会展活动策划"},{"label":"会展活动执行","value":"会展活动执行"}]},{"label":"广告","value":"广告","children":[{"label":"广告/会展项目经理","value":"广告/会展项目经理"},{"label":"广告创意设计","value":"广告创意设计"},{"label":"美术指导","value":"美术指导"},{"label":"广告设计","value":"广告设计"},{"label":"策划经理","value":"策划经理"},{"label":"广告文案","value":"广告文案"},{"label":"广告制作","value":"广告制作"},{"label":"媒介投放","value":"媒介投放"},{"label":"媒介合作","value":"媒介合作"},{"label":"广告审核","value":"广告审核"}]},{"label":"高端市场职位","value":"高端市场职位","children":[{"label":"市场总监","value":"市场总监"},{"label":"CMO","value":"CMO"},{"label":"公关总监","value":"公关总监"},{"label":"媒介总监","value":"媒介总监"},{"label":"创意总监","value":"创意总监"}]},{"label":"其他市场职位","value":"其他市场职位","children":[{"label":"其他市场职位","value":"其他市场职位"}]}]},{"label":"金融","value":"金融","children":[{"label":"投融资","value":"投融资","children":[{"label":"投资经理","value":"投资经理"},{"label":"行业研究","value":"行业研究"},{"label":"资产管理","value":"资产管理"},{"label":"投资总监","value":"投资总监"},{"label":"投资VP","value":"投资VP"},{"label":"投资合伙人","value":"投资合伙人"},{"label":"融资","value":"融资"},{"label":"并购","value":"并购"},{"label":"投后管理","value":"投后管理"},{"label":"投资助理","value":"投资助理"},{"label":"其他投融资职位","value":"其他投融资职位"},{"label":"投资顾问","value":"投资顾问"}]},{"label":"风控","value":"风控","children":[{"label":"风控","value":"风控"},{"label":"律师","value":"律师"},{"label":"资信评估","value":"资信评估"},{"label":"合规稽查","value":"合规稽查"}]},{"label":"税务审计","value":"税务审计","children":[{"label":"审计","value":"审计"},{"label":"法务","value":"法务"},{"label":"会计","value":"会计"},{"label":"清算","value":"清算"}]},{"label":"银行","value":"银行","children":[{"label":"分析师","value":"分析师"},{"label":"柜员","value":"柜员"},{"label":"商务渠道","value":"商务渠道"},{"label":"大堂经理","value":"大堂经理"},{"label":"客户经理","value":"客户经理"},{"label":"信贷管理","value":"信贷管理"},{"label":"风控","value":"风控"}]},{"label":"互联网金融","value":"互联网金融","children":[{"label":"金融产品经理","value":"金融产品经理"},{"label":"风控","value":"风控"},{"label":"催收员","value":"催收员"},{"label":"分析师","value":"分析师"},{"label":"投资经理","value":"投资经理"},{"label":"审计","value":"审计"},{"label":"清算","value":"清算"}]},{"label":"保险","value":"保险","children":[{"label":"保险精算师","value":"保险精算师"},{"label":"保险理赔","value":"保险理赔"}]},{"label":"证券","value":"证券","children":[{"label":"证券分析师","value":"证券分析师"},{"label":"交易员","value":"交易员"}]},{"label":"其他金融职位","value":"其他金融职位","children":[{"label":"其他金融职位","value":"其他金融职位"}]}]},{"label":"传媒","value":"传媒","children":[{"label":"采编/写作/出版","value":"采编/写作/出版","children":[{"label":"排版设计","value":"排版设计"},{"label":"记者","value":"记者"},{"label":"编辑","value":"编辑"},{"label":"采编","value":"采编"},{"label":"撰稿人","value":"撰稿人"},{"label":"出版发行","value":"出版发行"},{"label":"校对录入","value":"校对录入"},{"label":"总编","value":"总编"},{"label":"自媒体","value":"自媒体"}]},{"label":"公关媒介","value":"公关媒介","children":[{"label":"媒介经理","value":"媒介经理"},{"label":"媒介专员","value":"媒介专员"},{"label":"广告协调","value":"广告协调"},{"label":"品牌公关","value":"品牌公关"},{"label":"活动策划执行","value":"活动策划执行"},{"label":"媒介策划","value":"媒介策划"}]},{"label":"广告","value":"广告","children":[{"label":"广告/会展项目经理","value":"广告/会展项目经理"},{"label":"广告创意设计","value":"广告创意设计"},{"label":"美术指导","value":"美术指导"},{"label":"广告设计","value":"广告设计"},{"label":"策划经理","value":"策划经理"},{"label":"广告文案","value":"广告文案"},{"label":"广告制作","value":"广告制作"},{"label":"媒介投放","value":"媒介投放"},{"label":"媒介合作","value":"媒介合作"},{"label":"广告审核","value":"广告审核"}]},{"label":"影视媒体","value":"影视媒体","children":[{"label":"艺人助理","value":"艺人助理"},{"label":"主持人/DJ","value":"主持人/DJ"},{"label":"主播助理","value":"主播助理"},{"label":"灯光师","value":"灯光师"},{"label":"剪辑师","value":"剪辑师"},{"label":"影视特效","value":"影视特效"},{"label":"导演/编导","value":"导演/编导"},{"label":"摄影/摄像","value":"摄影/摄像"},{"label":"视频编辑","value":"视频编辑"},{"label":"音频编辑","value":"音频编辑"},{"label":"经纪人","value":"经纪人"},{"label":"后期制作","value":"后期制作"},{"label":"影视发行","value":"影视发行"},{"label":"影视策划","value":"影视策划"},{"label":"主播","value":"主播"},{"label":"演员/配音/模特","value":"演员/配音/模特"},{"label":"化妆/造型/服装","value":"化妆/造型/服装"},{"label":"放映员","value":"放映员"},{"label":"录音/音效","value":"录音/音效"},{"label":"制片人","value":"制片人"},{"label":"编剧","value":"编剧"}]},{"label":"其他传媒职位","value":"其他传媒职位","children":[{"label":"其他传媒职位","value":"其他传媒职位"}]}]},{"label":"教育培训","value":"教育培训","children":[{"label":"教育产品研发","value":"教育产品研发","children":[{"label":"课程设计","value":"课程设计"},{"label":"课程编辑","value":"课程编辑"},{"label":"培训研究","value":"培训研究"},{"label":"培训师","value":"培训师"},{"label":"培训策划","value":"培训策划"},{"label":"其他教育产品研发职位","value":"其他教育产品研发职位"}]},{"label":"教育行政","value":"教育行政","children":[{"label":"园长/副园长","value":"园长/副园长"},{"label":"校长/副校长","value":"校长/副校长"},{"label":"教务管理","value":"教务管理"},{"label":"教学管理","value":"教学管理"},{"label":"班主任/辅导员","value":"班主任/辅导员"}]},{"label":"教师","value":"教师","children":[{"label":"教师","value":"教师"},{"label":"日语教师","value":"日语教师"},{"label":"其他外语教师","value":"其他外语教师"},{"label":"语文教师","value":"语文教师"},{"label":"数学教师","value":"数学教师"},{"label":"物理教师","value":"物理教师"},{"label":"化学教师","value":"化学教师"},{"label":"生物教师","value":"生物教师"},{"label":"家教","value":"家教"},{"label":"托管老师","value":"托管老师"},{"label":"早教老师","value":"早教老师"},{"label":"助教","value":"助教"},{"label":"高中教师","value":"高中教师"},{"label":"初中教师","value":"初中教师"},{"label":"小学教师","value":"小学教师"},{"label":"幼教","value":"幼教"},{"label":"理科教师","value":"理科教师"},{"label":"文科教师","value":"文科教师"},{"label":"英语教师","value":"英语教师"},{"label":"音乐教师","value":"音乐教师"},{"label":"美术教师","value":"美术教师"},{"label":"体育教师","value":"体育教师"},{"label":"就业老师","value":"就业老师"}]},{"label":"IT培训","value":"IT培训","children":[{"label":"JAVA培训讲师","value":"JAVA培训讲师"},{"label":"Android培训讲师","value":"Android培训讲师"},{"label":"iOS培训讲师","value":"iOS培训讲师"},{"label":"PHP培训讲师","value":"PHP培训讲师"},{"label":".NET培训讲师","value":".NET培训讲师"},{"label":"C++培训讲师","value":"C++培训讲师"},{"label":"Unity 3D培训讲师","value":"Unity 3D培训讲师"},{"label":"Web前端培训讲师","value":"Web前端培训讲师"},{"label":"软件测试培训讲师","value":"软件测试培训讲师"},{"label":"动漫培训讲师","value":"动漫培训讲师"},{"label":"UI设计培训讲师","value":"UI设计培训讲师"}]},{"label":"职业培训","value":"职业培训","children":[{"label":"财会培训讲师","value":"财会培训讲师"},{"label":"HR培训讲师","value":"HR培训讲师"},{"label":"培训师","value":"培训师"},{"label":"拓展培训","value":"拓展培训"}]},{"label":"特长培训","value":"特长培训","children":[{"label":"武术教练","value":"武术教练"},{"label":"轮滑教练","value":"轮滑教练"},{"label":"表演教师","value":"表演教师"},{"label":"机器人教师","value":"机器人教师"},{"label":"书法教师","value":"书法教师"},{"label":"钢琴教师","value":"钢琴教师"},{"label":"吉他教师","value":"吉他教师"},{"label":"古筝教师","value":"古筝教师"},{"label":"播音主持教师","value":"播音主持教师"},{"label":"乐高教师","value":"乐高教师"},{"label":"舞蹈老师","value":"舞蹈老师"},{"label":"瑜伽老师","value":"瑜伽老师"},{"label":"游泳教练","value":"游泳教练"},{"label":"健身教练","value":"健身教练"},{"label":"篮球/羽毛球教练","value":"篮球/羽毛球教练"},{"label":"跆拳道教练","value":"跆拳道教练"}]},{"label":"其他教育培训职位","value":"其他教育培训职位","children":[{"label":"其他教育培训职位","value":"其他教育培训职位"}]}]},{"label":"产品","value":"产品","children":[{"label":"产品经理","value":"产品经理","children":[{"label":"产品经理","value":"产品经理"},{"label":"网页产品经理","value":"网页产品经理"},{"label":"移动产品经理","value":"移动产品经理"},{"label":"产品助理","value":"产品助理"},{"label":"数据产品经理","value":"数据产品经理"},{"label":"电商产品经理","value":"电商产品经理"},{"label":"游戏策划","value":"游戏策划"},{"label":"产品专员","value":"产品专员"},{"label":"硬件产品经理","value":"硬件产品经理"}]},{"label":"高端产品职位","value":"高端产品职位","children":[{"label":"产品总监","value":"产品总监"},{"label":"游戏制作人","value":"游戏制作人"},{"label":"产品VP","value":"产品VP"}]},{"label":"其他产品职位","value":"其他产品职位","children":[{"label":"其他产品职位","value":"其他产品职位"}]}]},{"label":"房地产/建筑","value":"房地产/建筑","children":[{"label":"房地产规划开发","value":"房地产规划开发","children":[{"label":"房地产策划","value":"房地产策划"},{"label":"地产项目管理","value":"地产项目管理"},{"label":"地产招投标","value":"地产招投标"},{"label":"房产评估师","value":"房产评估师"}]},{"label":"设计装修与市政建设","value":"设计装修与市政建设","children":[{"label":"建筑工程师","value":"建筑工程师"},{"label":"建筑设计师","value":"建筑设计师"},{"label":"土木/土建/结构工程师","value":"土木/土建/结构工程师"},{"label":"室内设计","value":"室内设计"},{"label":"园林/景观设计","value":"园林/景观设计"},{"label":"城市规划设计","value":"城市规划设计"},{"label":"工程监理","value":"工程监理"},{"label":"工程造价","value":"工程造价"},{"label":"工程预算","value":"工程预算"},{"label":"资料员","value":"资料员"},{"label":"建筑施工现场管理","value":"建筑施工现场管理"},{"label":"弱电工程师","value":"弱电工程师"},{"label":"给排水工程师","value":"给排水工程师"},{"label":"暖通工程师","value":"暖通工程师"},{"label":"幕墙工程师","value":"幕墙工程师"},{"label":"软装设计师","value":"软装设计师"},{"label":"施工员","value":"施工员"},{"label":"测绘/测量","value":"测绘/测量"},{"label":"材料员","value":"材料员"},{"label":"BIM工程师","value":"BIM工程师"},{"label":"装修项目经理","value":"装修项目经理"},{"label":"建筑机电工程师","value":"建筑机电工程师"},{"label":"消防工程师","value":"消防工程师"},{"label":"施工安全员","value":"施工安全员"}]},{"label":"物业管理","value":"物业管理","children":[{"label":"物业经理","value":"物业经理"},{"label":"物业维修","value":"物业维修"},{"label":"绿化工","value":"绿化工"},{"label":"物业管理员","value":"物业管理员"}]},{"label":"高端房地产职位","value":"高端房地产职位","children":[{"label":"地产项目总监","value":"地产项目总监"},{"label":"地产策划总监","value":"地产策划总监"},{"label":"地产招投标总监","value":"地产招投标总监"}]},{"label":"其他房地产职位","value":"其他房地产职位","children":[{"label":"其他房地产职位","value":"其他房地产职位"}]}]},{"label":"采购/贸易","value":"采购/贸易","children":[{"label":"采购","value":"采购","children":[{"label":"商品经理","value":"商品经理"},{"label":"供应商质量工程师","value":"供应商质量工程师"},{"label":"采购总监","value":"采购总监"},{"label":"采购经理","value":"采购经理"},{"label":"采购专员","value":"采购专员"},{"label":"买手","value":"买手"},{"label":"采购工程师","value":"采购工程师"},{"label":"采购主管","value":"采购主管"},{"label":"采购助理","value":"采购助理"}]},{"label":"进出口贸易","value":"进出口贸易","children":[{"label":"贸易跟单","value":"贸易跟单"},{"label":"报关/报检员","value":"报关/报检员"},{"label":"单证员","value":"单证员"}]},{"label":"其他采购/贸易职位","value":"其他采购/贸易职位","children":[{"label":"其他采购/贸易类职位","value":"其他采购/贸易类职位"}]}]},{"label":"服务业","value":"服务业","children":[{"label":"餐饮","value":"餐饮","children":[{"label":"后厨","value":"后厨"},{"label":"配菜打荷","value":"配菜打荷"},{"label":"茶艺师","value":"茶艺师"},{"label":"西点师","value":"西点师"},{"label":"餐饮学徒","value":"餐饮学徒"},{"label":"面点师","value":"面点师"},{"label":"行政总厨","value":"行政总厨"},{"label":"厨师长","value":"厨师长"},{"label":"传菜员","value":"传菜员"},{"label":"洗碗工","value":"洗碗工"},{"label":"凉菜厨师","value":"凉菜厨师"},{"label":"中餐厨师","value":"中餐厨师"},{"label":"西餐厨师","value":"西餐厨师"},{"label":"日料厨师","value":"日料厨师"},{"label":"烧烤师傅","value":"烧烤师傅"},{"label":"收银","value":"收银"},{"label":"服务员","value":"服务员"},{"label":"厨师","value":"厨师"},{"label":"咖啡师","value":"咖啡师"},{"label":"送餐员","value":"送餐员"},{"label":"餐饮店长","value":"餐饮店长"},{"label":"领班","value":"领班"}]},{"label":"酒店","value":"酒店","children":[{"label":"礼仪/迎宾/接待","value":"礼仪/迎宾/接待"},{"label":"前厅经理","value":"前厅经理"},{"label":"客房经理","value":"客房经理"},{"label":"收银","value":"收银"},{"label":"酒店前台","value":"酒店前台"},{"label":"客房服务员","value":"客房服务员"},{"label":"酒店经理","value":"酒店经理"}]},{"label":"零售","value":"零售","children":[{"label":"督导/巡店","value":"督导/巡店"},{"label":"陈列员","value":"陈列员"},{"label":"理货员","value":"理货员"},{"label":"防损员","value":"防损员"},{"label":"卖场经理","value":"卖场经理"},{"label":"促销员","value":"促销员"},{"label":"收银","value":"收银"},{"label":"导购","value":"导购"},{"label":"店员/营业员","value":"店员/营业员"},{"label":"门店店长","value":"门店店长"}]},{"label":"美容保健","value":"美容保健","children":[{"label":"纹绣师","value":"纹绣师"},{"label":"美体师","value":"美体师"},{"label":"美发学徒","value":"美发学徒"},{"label":"美容店长","value":"美容店长"},{"label":"足疗师","value":"足疗师"},{"label":"按摩师","value":"按摩师"},{"label":"美睫师","value":"美睫师"},{"label":"发型师","value":"发型师"},{"label":"美甲师","value":"美甲师"},{"label":"化妆师","value":"化妆师"},{"label":"养发师","value":"养发师"},{"label":"美容师","value":"美容师"}]},{"label":"运动健身","value":"运动健身","children":[{"label":"救生员","value":"救生员"},{"label":"瑜伽老师","value":"瑜伽老师"},{"label":"游泳教练","value":"游泳教练"},{"label":"美体教练","value":"美体教练"},{"label":"舞蹈老师","value":"舞蹈老师"},{"label":"健身教练","value":"健身教练"}]},{"label":"婚礼/花艺","value":"婚礼/花艺","children":[{"label":"花艺师","value":"花艺师"},{"label":"婚礼策划","value":"婚礼策划"}]},{"label":"宠物服务","value":"宠物服务","children":[{"label":"宠物美容","value":"宠物美容"},{"label":"宠物医生","value":"宠物医生"}]},{"label":"安保/家政/维修","value":"安保/家政/维修","children":[{"label":"保安","value":"保安"},{"label":"保洁","value":"保洁"},{"label":"保姆","value":"保姆"},{"label":"月嫂","value":"月嫂"},{"label":"育婴师","value":"育婴师"},{"label":"护工","value":"护工"},{"label":"地铁安检","value":"地铁安检"},{"label":"手机维修","value":"手机维修"},{"label":"家电维修","value":"家电维修"},{"label":"保安经理","value":"保安经理"},{"label":"产后康复师","value":"产后康复师"},{"label":"钟点工","value":"钟点工"},{"label":"押运员","value":"押运员"},{"label":"消防中控员","value":"消防中控员"},{"label":"保洁经理","value":"保洁经理"}]},{"label":"其他服务业职位","value":"其他服务业职位","children":[{"label":"其他服务业职位","value":"其他服务业职位"}]}]},{"label":"供应链/物流","value":"供应链/物流","children":[{"label":"物流","value":"物流","children":[{"label":"供应链专员","value":"供应链专员"},{"label":"供应链经理","value":"供应链经理"},{"label":"集装箱管理","value":"集装箱管理"},{"label":"物流专员","value":"物流专员"},{"label":"物流经理","value":"物流经理"},{"label":"物流运营","value":"物流运营"},{"label":"物流跟单","value":"物流跟单"},{"label":"调度员","value":"调度员"},{"label":"物流/仓储项目经理","value":"物流/仓储项目经理"},{"label":"货运代理专员","value":"货运代理专员"},{"label":"货运代理经理","value":"货运代理经理"},{"label":"水/空/陆运操作","value":"水/空/陆运操作"},{"label":"核销员","value":"核销员"}]},{"label":"仓储","value":"仓储","children":[{"label":"仓库经理","value":"仓库经理"},{"label":"仓库管理员","value":"仓库管理员"},{"label":"仓库文员","value":"仓库文员"},{"label":"配/理/拣/发货","value":"配/理/拣/发货"}]},{"label":"交通/运输","value":"交通/运输","children":[{"label":"商务司机","value":"商务司机"},{"label":"网约车司机","value":"网约车司机"},{"label":"代驾司机","value":"代驾司机"},{"label":"驾校教练","value":"驾校教练"},{"label":"货运司机","value":"货运司机"},{"label":"配送员","value":"配送员"},{"label":"快递员","value":"快递员"},{"label":"运输经理/主管","value":"运输经理/主管"}]},{"label":"高端供应链职位","value":"高端供应链职位","children":[{"label":"供应链总监","value":"供应链总监"},{"label":"物流总监","value":"物流总监"}]},{"label":"其他供应链职位","value":"其他供应链职位","children":[{"label":"其他供应链职位","value":"其他供应链职位"}]}]},{"label":"医疗健康","value":"医疗健康","children":[{"label":"临床试验","value":"临床试验","children":[{"label":"临床研究","value":"临床研究"},{"label":"临床协调","value":"临床协调"},{"label":"临床数据分析","value":"临床数据分析"},{"label":"临床项目经理","value":"临床项目经理"},{"label":"医学总监","value":"医学总监"}]},{"label":"医生/医技","value":"医生/医技","children":[{"label":"医生","value":"医生"},{"label":"医生助理","value":"医生助理"},{"label":"医学影像/放射科医师","value":"医学影像/放射科医师"},{"label":"B超医生","value":"B超医生"},{"label":"内科医生","value":"内科医生"},{"label":"全科医生","value":"全科医生"},{"label":"中医","value":"中医"},{"label":"心理医生","value":"心理医生"},{"label":"药剂师","value":"药剂师"},{"label":"牙科医生","value":"牙科医生"},{"label":"康复治疗师","value":"康复治疗师"},{"label":"验光师","value":"验光师"},{"label":"检验科医师","value":"检验科医师"},{"label":"其他医生职位","value":"其他医生职位"}]},{"label":"护士/护理","value":"护士/护理","children":[{"label":"护士长","value":"护士长"},{"label":"护士","value":"护士"},{"label":"导医","value":"导医"}]},{"label":"健康整形","value":"健康整形","children":[{"label":"营养师","value":"营养师"},{"label":"整形师","value":"整形师"},{"label":"理疗师","value":"理疗师"},{"label":"针灸推拿","value":"针灸推拿"}]},{"label":"生物制药","value":"生物制药","children":[{"label":"生物制药","value":"生物制药"},{"label":"药品注册","value":"药品注册"},{"label":"药品生产","value":"药品生产"},{"label":"医药项目经理","value":"医药项目经理"},{"label":"医药研发","value":"医药研发"}]},{"label":"医疗器械","value":"医疗器械","children":[{"label":"医疗器械注册","value":"医疗器械注册"},{"label":"医疗器械生产/质量管理","value":"医疗器械生产/质量管理"},{"label":"医疗器械研发","value":"医疗器械研发"}]},{"label":"药店","value":"药店","children":[{"label":"药店店长","value":"药店店长"},{"label":"执业药师/驻店药师","value":"执业药师/驻店药师"},{"label":"药店店员","value":"药店店员"}]},{"label":"其他医疗健康职位","value":"其他医疗健康职位","children":[{"label":"其他医疗健康职位","value":"其他医疗健康职位"}]}]},{"label":"生产制造","value":"生产制造","children":[{"label":"生产营运","value":"生产营运","children":[{"label":"厂长","value":"厂长"},{"label":"生产总监","value":"生产总监"},{"label":"车间主任","value":"车间主任"},{"label":"生产组长/拉长","value":"生产组长/拉长"},{"label":"生产员","value":"生产员"},{"label":"生产设备管理","value":"生产设备管理"},{"label":"生产计划管理","value":"生产计划管理"},{"label":"生产跟单","value":"生产跟单"}]},{"label":"质量安全","value":"质量安全","children":[{"label":"质检员","value":"质检员"},{"label":"质量管理/测试","value":"质量管理/测试"},{"label":"可靠度工程师","value":"可靠度工程师"},{"label":"故障分析师","value":"故障分析师"},{"label":"认证工程师","value":"认证工程师"},{"label":"体系工程师","value":"体系工程师"},{"label":"审核员","value":"审核员"},{"label":"生产安全员","value":"生产安全员"},{"label":"汽车质量工程师","value":"汽车质量工程师"}]},{"label":"新能源","value":"新能源","children":[{"label":"电池工程师","value":"电池工程师"},{"label":"电机工程师","value":"电机工程师"},{"label":"线束设计","value":"线束设计"},{"label":"充电桩设计","value":"充电桩设计"}]},{"label":"汽车制造","value":"汽车制造","children":[{"label":"汽车设计","value":"汽车设计"},{"label":"车身/造型设计","value":"车身/造型设计"},{"label":"底盘工程师","value":"底盘工程师"},{"label":"动力系统工程师","value":"动力系统工程师"},{"label":"汽车电子工程师","value":"汽车电子工程师"},{"label":"汽车零部件设计","value":"汽车零部件设计"},{"label":"汽车项目管理","value":"汽车项目管理"},{"label":"内外饰设计工程师","value":"内外饰设计工程师"},{"label":"总装工程师","value":"总装工程师"}]},{"label":"汽车服务","value":"汽车服务","children":[{"label":"汽车服务顾问","value":"汽车服务顾问"},{"label":"汽车维修","value":"汽车维修"},{"label":"汽车美容","value":"汽车美容"},{"label":"汽车定损理赔","value":"汽车定损理赔"},{"label":"二手车评估师","value":"二手车评估师"},{"label":"4S店店长/维修站长","value":"4S店店长/维修站长"},{"label":"汽车改装工程师","value":"汽车改装工程师"}]},{"label":"机械设计/制造","value":"机械设计/制造","children":[{"label":"热设计工程师","value":"热设计工程师"},{"label":"精益工程师","value":"精益工程师"},{"label":"机械工程师","value":"机械工程师"},{"label":"机械设计师","value":"机械设计师"},{"label":"机械设备工程师","value":"机械设备工程师"},{"label":"机械维修/保养","value":"机械维修/保养"},{"label":"机械制图","value":"机械制图"},{"label":"机械结构工程师","value":"机械结构工程师"},{"label":"工业工程师","value":"工业工程师"},{"label":"工艺/制程工程师","value":"工艺/制程工程师"},{"label":"材料工程师","value":"材料工程师"},{"label":"机电工程师","value":"机电工程师"},{"label":"CNC/数控","value":"CNC/数控"},{"label":"冲压工程师","value":"冲压工程师"},{"label":"夹具工程师","value":"夹具工程师"},{"label":"模具工程师","value":"模具工程师"},{"label":"焊接工程师","value":"焊接工程师"},{"label":"注塑工程师","value":"注塑工程师"},{"label":"铸造/锻造工程师","value":"铸造/锻造工程师"}]},{"label":"化工","value":"化工","children":[{"label":"化工项目经理","value":"化工项目经理"},{"label":"化工工程师","value":"化工工程师"},{"label":"实验室技术员","value":"实验室技术员"},{"label":"化学分析","value":"化学分析"},{"label":"涂料研发","value":"涂料研发"},{"label":"化妆品研发","value":"化妆品研发"},{"label":"食品/饮料研发","value":"食品/饮料研发"}]},{"label":"服装/纺织/皮革","value":"服装/纺织/皮革","children":[{"label":"服装/纺织设计","value":"服装/纺织设计"},{"label":"面料辅料开发","value":"面料辅料开发"},{"label":"打样/制版","value":"打样/制版"},{"label":"服装/纺织/皮革跟单","value":"服装/纺织/皮革跟单"}]},{"label":"技工/普工","value":"技工/普工","children":[{"label":"普工/操作工","value":"普工/操作工"},{"label":"叉车工","value":"叉车工"},{"label":"铲车司机","value":"铲车司机"},{"label":"焊工","value":"焊工"},{"label":"氩弧焊工","value":"氩弧焊工"},{"label":"电工","value":"电工"},{"label":"木工","value":"木工"},{"label":"油漆工","value":"油漆工"},{"label":"车工","value":"车工"},{"label":"磨工","value":"磨工"},{"label":"铣工","value":"铣工"},{"label":"钳工","value":"钳工"},{"label":"钻工","value":"钻工"},{"label":"铆工","value":"铆工"},{"label":"钣金工","value":"钣金工"},{"label":"抛光工","value":"抛光工"},{"label":"机修工","value":"机修工"},{"label":"折弯工","value":"折弯工"},{"label":"电镀工","value":"电镀工"},{"label":"喷塑工","value":"喷塑工"},{"label":"注塑工","value":"注塑工"},{"label":"组装工","value":"组装工"},{"label":"包装工","value":"包装工"},{"label":"空调工","value":"空调工"},{"label":"电梯工","value":"电梯工"},{"label":"锅炉工","value":"锅炉工"},{"label":"学徒工","value":"学徒工"},{"label":"缝纫工","value":"缝纫工"},{"label":"搬运工","value":"搬运工"},{"label":"切割工","value":"切割工"},{"label":"样衣工","value":"样衣工"},{"label":"模具工","value":"模具工"}]},{"label":"其他生产制造职位","value":"其他生产制造职位","children":[{"label":"其他生产制造职位","value":"其他生产制造职位"}]}]},{"label":"咨询/翻译/法律","value":"咨询/翻译/法律","children":[{"label":"咨询/调研","value":"咨询/调研","children":[{"label":"知识产权/专利/商标代理人","value":"知识产权/专利/商标代理人"},{"label":"心理咨询师","value":"心理咨询师"},{"label":"婚恋咨询师","value":"婚恋咨询师"},{"label":"企业管理咨询","value":"企业管理咨询"},{"label":"咨询总监","value":"咨询总监"},{"label":"数据分析师","value":"数据分析师"},{"label":"咨询经理","value":"咨询经理"},{"label":"财务咨询顾问","value":"财务咨询顾问"},{"label":"IT咨询顾问","value":"IT咨询顾问"},{"label":"人力资源咨询顾问","value":"人力资源咨询顾问"},{"label":"咨询项目管理","value":"咨询项目管理"},{"label":"战略咨询","value":"战略咨询"},{"label":"猎头顾问","value":"猎头顾问"},{"label":"市场调研","value":"市场调研"},{"label":"其他咨询顾问","value":"其他咨询顾问"}]},{"label":"律师","value":"律师","children":[{"label":"专利律师","value":"专利律师"},{"label":"知识产权律师","value":"知识产权律师"},{"label":"律师助理","value":"律师助理"},{"label":"事务所律师","value":"事务所律师"},{"label":"法务","value":"法务"}]},{"label":"翻译","value":"翻译","children":[{"label":"英语翻译","value":"英语翻译"},{"label":"日语翻译","value":"日语翻译"},{"label":"韩语/朝鲜语翻译","value":"韩语/朝鲜语翻译"},{"label":"法语翻译","value":"法语翻译"},{"label":"德语翻译","value":"德语翻译"},{"label":"俄语翻译","value":"俄语翻译"},{"label":"西班牙语翻译","value":"西班牙语翻译"},{"label":"其他语种翻译","value":"其他语种翻译"}]},{"label":"其他咨询类职位","value":"其他咨询类职位","children":[{"label":"其他咨询/翻译类职位","value":"其他咨询/翻译类职位"}]}]},{"label":"旅游","value":"旅游","children":[{"label":"旅游服务","value":"旅游服务","children":[{"label":"计调","value":"计调"},{"label":"签证专员","value":"签证专员"},{"label":"导游","value":"导游"},{"label":"预定票务","value":"预定票务"},{"label":"讲解员","value":"讲解员"}]},{"label":"旅游产品开发/策划","value":"旅游产品开发/策划","children":[{"label":"旅游产品经理","value":"旅游产品经理"},{"label":"旅游策划师","value":"旅游策划师"}]},{"label":"其他旅游职位","value":"其他旅游职位","children":[{"label":"其他旅游职位","value":"其他旅游职位"}]}]},{"label":"其他","value":"其他","children":[{"label":"其他职位类别","value":"其他职位类别","children":[{"label":"其他职位","value":"其他职位"}]}]}];

export const qzArea = [
          {value: "",label: "全部"},
          {value: "柯城区",label: "柯城区"},
          {value: "衢江区",label: "衢江区"},
          {value: "江山市",label: "江山市"},
          {value: "龙游县",label: "龙游县"},
          {value: "开化县",label: "开化县"},
          {value: "常山县",label: "常山县"}
]
export const city = [
  {
    value: "浙江省",
    level: "1",
    code: "3300",
    children: [
      { value: "杭州市", level: "2", code: "3301", label: "杭州市" },
      { value: "宁波市", level: "3", code: "3302", label: "宁波市" },
      { value: "温州市", level: "3", code: "3303", label: "温州市" },
      { value: "嘉兴市", level: "3", code: "3304", label: "嘉兴市" },
      { value: "湖州市", level: "3", code: "3305", label: "湖州市" },
      { value: "绍兴市", level: "3", code: "3306", label: "绍兴市" },
      { value: "金华市", level: "3", code: "3307", label: "金华市" },
      { value: "衢州市", level: "3", code: "3308", label: "衢州市" ,
        // children:[
        //   {value: "柯城区",label: "柯城区"},
        //   {value: "衢江区",label: "衢江区"},
        //   {value: "江山市",label: "江山市"},
        //   {value: "龙游县",label: "龙游县"},
        //   {value: "开化县",label: "开化县"}
        // ]
      },
      { value: "舟山市", level: "3", code: "3309", label: "舟山市" },
      { value: "台州市", level: "3", code: "3310", label: "台州市" },
      { value: "丽水市", level: "3", code: "3311", label: "丽水市" }
    ],
    label: "浙江省"
  },
  {
    value: "天津市",
    label: "天津市",
    level: "1",
    code: "1200",
    children: [{ value: "天津市", level: "1", code: "1200", label: "天津市" }]
  },
  {
    value: "河北省",
    label: "河北省",
    level: "1",
    code: "1300",
    children: [
      { value: "石家庄市", label: "石家庄市", level: "2", code: "1301" },
      { value: "唐山市", label: "唐山市", level: "3", code: "1302" },
      { value: "秦皇岛市", label: "秦皇岛市", level: "3", code: "1303" },
      { value: "邯郸市", level: "3", code: "1304", label: "邯郸市" },
      { value: "邢台市", level: "3", code: "1305", label: "邢台市" },
      { value: "保定市", level: "3", code: "1306", label: "保定市" },
      { value: "张家口市", level: "3", code: "1307", label: "张家口市" },
      { value: "承德市", level: "3", code: "1308", label: "承德市" },
      { value: "沧州市", level: "3", code: "1309", label: "沧州市" },
      { value: "廊坊市", level: "3", code: "1310", label: "廊坊市" },
      { value: "衡水市", level: "3", code: "1311", label: "衡水市" }
    ]
  },
  {
    value: "山西省",
    level: "1",
    code: "1400",
    children: [
      { value: "太原市", level: "2", code: "1401", label: "太原市" },
      { value: "大同市", level: "3", code: "1402", label: "大同市" },
      { value: "阳泉市", level: "3", code: "1403", label: "阳泉市" },
      { value: "长治市", level: "3", code: "1404", label: "长治市" },
      { value: "晋城市", level: "3", code: "1405", label: "晋城市" },
      { value: "朔州市", level: "3", code: "1406", label: "朔州市" },
      { value: "晋中市", level: "3", code: "1407", label: "晋中市" },
      { value: "运城市", level: "3", code: "1408", label: "运城市" },
      { value: "忻州市", level: "3", code: "1409", label: "忻州市" },
      { value: "临汾市", level: "3", code: "1410", label: "临汾市" },
      { value: "吕梁市", level: "3", code: "1411", label: "吕梁市" }
    ],
    label: "山西省"
  },
  {
    value: "内蒙古自治区",
    level: "1",
    code: "1500",
    children: [
      { value: "呼和浩特市", level: "2", code: "1501", label: "呼和浩特市" },
      { value: "包头市", level: "3", code: "1502", label: "包头市" },
      { value: "乌海市", level: "3", code: "1503", label: "乌海市" },
      { value: "赤峰市", level: "3", code: "1504", label: "赤峰市" },
      { value: "通辽市", level: "3", code: "1505", label: "通辽市" },
      { value: "鄂尔多斯市", level: "3", code: "1506", label: "鄂尔多斯市" },
      { value: "呼伦贝尔市", level: "3", code: "1507", label: "呼伦贝尔市" },
      { value: "巴彦淖尔市", level: "3", code: "1508", label: "巴彦淖尔市" },
      { value: "乌兰察布市", level: "3", code: "1509", label: "乌兰察布市" },
      { value: "兴安盟", level: "3", code: "1522", label: "兴安盟" },
      { value: "锡林郭勒盟", level: "3", code: "1525", label: "锡林郭勒盟" },
      { value: "阿拉善盟", level: "3", code: "1529", label: "阿拉善盟" }
    ],
    label: "内蒙古自治区"
  },
  {
    value: "辽宁省",
    level: "1",
    code: "2100",
    children: [
      { value: "沈阳市", level: "2", code: "2101", label: "沈阳市" },
      { value: "大连市", level: "3", code: "2102", label: "大连市" },
      { value: "鞍山市", level: "3", code: "2103", label: "鞍山市" },
      { value: "抚顺市", level: "3", code: "2104", label: "抚顺市" },
      { value: "本溪市", level: "3", code: "2105", label: "本溪市" },
      { value: "丹东市", level: "3", code: "2106", label: "丹东市" },
      { value: "锦州市", level: "3", code: "2107", label: "锦州市" },
      { value: "营口市", level: "3", code: "2108", label: "营口市" },
      { value: "阜新市", level: "3", code: "2109", label: "阜新市" },
      { value: "辽阳市", level: "3", code: "2110", label: "辽阳市" },
      { value: "盘锦市", level: "3", code: "2111", label: "盘锦市" },
      { value: "铁岭市", level: "3", code: "2112", label: "铁岭市" },
      { value: "朝阳市", level: "3", code: "2113", label: "朝阳市" },
      { value: "葫芦岛市", level: "3", code: "2114", label: "葫芦岛市" }
    ],
    label: "辽宁省"
  },
  {
    value: "吉林省",
    level: "1",
    code: "2200",
    children: [
      { value: "长春市", level: "2", code: "2201", label: "长春市" },
      { value: "吉林市", level: "3", code: "2202", label: "吉林市" },
      { value: "四平市", level: "3", code: "2203", label: "四平市" },
      { value: "辽源市", level: "3", code: "2204", label: "辽源市" },
      { value: "通化市", level: "3", code: "2205", label: "通化市" },
      { value: "白山市", level: "3", code: "2206", label: "白山市" },
      { value: "松原市", level: "3", code: "2207", label: "松原市" },
      { value: "白城市", level: "3", code: "2208", label: "白城市" },
      {
        value: "延边朝鲜族自治州",
        level: "3",
        code: "2224",
        label: "延边朝鲜族自治州"
      }
    ],
    label: "吉林省"
  },
  {
    value: "黑龙江省",
    level: "1",
    code: "2300",
    children: [
      { value: "哈尔滨市", level: "2", code: "2301", label: "哈尔滨市" },
      { value: "齐齐哈尔市", level: "3", code: "2302", label: "齐齐哈尔市" },
      { value: "鸡西市", level: "3", code: "2303", label: "鸡西市" },
      { value: "鹤岗市", level: "3", code: "2304", label: "鹤岗市" },
      { value: "双鸭山市", level: "3", code: "2305", label: "双鸭山市" },
      { value: "大庆市", level: "3", code: "2306", label: "大庆市" },
      { value: "伊春市", level: "3", code: "2307", label: "伊春市" },
      { value: "佳木斯市", level: "3", code: "2308", label: "佳木斯市" },
      { value: "七台河市", level: "3", code: "2309", label: "七台河市" },
      { value: "牡丹江市", level: "3", code: "2310", label: "牡丹江市" },
      { value: "黑河市", level: "3", code: "2311", label: "黑河市" },
      { value: "绥化市", level: "3", code: "2312", label: "绥化市" },
      { value: "大兴安岭地区", level: "3", code: "2327", label: "大兴安岭地区" }
    ],
    label: "黑龙江省"
  },
  {
    value: "上海市",
    level: "1",
    code: "3100",
    children: [
      { value: "上海市", level: "1", code: "3100", label: "上海市" },
    ],
    label: "上海市"
  },
  {
    value: "北京市",
    level: "1",
    code: "3100",
    children: [
      { value: "北京市", level: "1", code: "3100", label: "北京市" },
    ],
    label: "北京市"
  },
  {
    value: "江苏省",
    level: "1",
    code: "3200",
    children: [
      { value: "南京市", level: "2", code: "3201", label: "南京市" },
      { value: "无锡市", level: "3", code: "3202", label: "无锡市" },
      { value: "徐州市", level: "3", code: "3203", label: "徐州市" },
      { value: "常州市", level: "3", code: "3204", label: "常州市" },
      { value: "苏州市", level: "3", code: "3205", label: "苏州市" },
      { value: "南通市", level: "3", code: "3206", label: "南通市" },
      { value: "连云港市", level: "3", code: "3207", label: "连云港市" },
      { value: "淮安市", level: "3", code: "3208", label: "淮安市" },
      { value: "盐城市", level: "3", code: "3209", label: "盐城市" },
      { value: "扬州市", level: "3", code: "3210", label: "扬州市" },
      { value: "镇江市", level: "3", code: "3211", label: "镇江市" },
      { value: "泰州市", level: "3", code: "3212", label: "泰州市" },
      { value: "宿迁市", level: "3", code: "3213", label: "宿迁市" }
    ],
    label: "江苏省"
  },
  {
    value: "安徽省",
    level: "1",
    code: "3400",
    children: [
      { value: "合肥市", level: "2", code: "3401", label: "合肥市" },
      { value: "芜湖市", level: "3", code: "3402", label: "芜湖市" },
      { value: "蚌埠市", level: "3", code: "3403", label: "蚌埠市" },
      { value: "淮南市", level: "3", code: "3404", label: "淮南市" },
      { value: "马鞍山市", level: "3", code: "3405", label: "马鞍山市" },
      { value: "淮北市", level: "3", code: "3406", label: "淮北市" },
      { value: "铜陵市", level: "3", code: "3407", label: "铜陵市" },
      { value: "安庆市", level: "3", code: "3408", label: "安庆市" },
      { value: "黄山市", level: "3", code: "3410", label: "黄山市" },
      { value: "滁州市", level: "3", code: "3411", label: "滁州市" },
      { value: "阜阳市", level: "3", code: "3412", label: "阜阳市" },
      { value: "宿州市", level: "3", code: "3413", label: "宿州市" },
      { value: "巢湖市", level: "3", code: "3414", label: "巢湖市" },
      { value: "六安市", level: "3", code: "3415", label: "六安市" },
      { value: "亳州市", level: "3", code: "3416", label: "亳州市" },
      { value: "池州市", level: "3", code: "3417", label: "池州市" },
      { value: "宣城市", level: "3", code: "3418", label: "宣城市" }
    ],
    label: "安徽省"
  },
  {
    value: "福建省",
    level: "1",
    code: "3500",
    children: [
      { value: "福州市", level: "2", code: "3501", label: "福州市" },
      { value: "厦门市", level: "3", code: "3502", label: "厦门市" },
      { value: "莆田市", level: "3", code: "3503", label: "莆田市" },
      { value: "三明市", level: "3", code: "3504", label: "三明市" },
      { value: "泉州市", level: "3", code: "3505", label: "泉州市" },
      { value: "漳州市", level: "3", code: "3506", label: "漳州市" },
      { value: "南平市", level: "3", code: "3507", label: "南平市" },
      { value: "龙岩市", level: "3", code: "3508", label: "龙岩市" },
      { value: "宁德市", level: "3", code: "3509", label: "宁德市" }
    ],
    label: "福建省"
  },
  {
    value: "江西省",
    level: "1",
    code: "3600",
    children: [
      { value: "南昌市", level: "2", code: "3601", label: "南昌市" },
      { value: "景德镇市", level: "3", code: "3602", label: "景德镇市" },
      { value: "萍乡市", level: "3", code: "3603", label: "萍乡市" },
      { value: "九江市", level: "3", code: "3604", label: "九江市" },
      { value: "新余市", level: "3", code: "3605", label: "新余市" },
      { value: "鹰潭市", level: "3", code: "3606", label: "鹰潭市" },
      { value: "赣州市", level: "3", code: "3607", label: "赣州市" },
      { value: "吉安市", level: "3", code: "3608", label: "吉安市" },
      { value: "宜春市", level: "3", code: "3609", label: "宜春市" },
      { value: "抚州市", level: "3", code: "3610", label: "抚州市" },
      { value: "上饶市", level: "3", code: "3611", label: "上饶市" }
    ],
    label: "江西省"
  },
  {
    value: "山东省",
    level: "1",
    code: "3700",
    children: [
      { value: "济南市", level: "2", code: "3701", label: "济南市" },
      { value: "青岛市", level: "3", code: "3702", label: "青岛市" },
      { value: "淄博市", level: "3", code: "3703", label: "淄博市" },
      { value: "枣庄市", level: "3", code: "3704", label: "枣庄市" },
      { value: "东营市", level: "3", code: "3705", label: "东营市" },
      { value: "烟台市", level: "3", code: "3706", label: "烟台市" },
      { value: "潍坊市", level: "3", code: "3707", label: "潍坊市" },
      { value: "济宁市", level: "3", code: "3708", label: "济宁市" },
      { value: "泰安市", level: "3", code: "3709", label: "泰安市" },
      { value: "威海市", level: "3", code: "3710", label: "威海市" },
      { value: "日照市", level: "3", code: "3711", label: "日照市" },
      { value: "莱芜市", level: "3", code: "3712", label: "莱芜市" },
      { value: "临沂市", level: "3", code: "3713", label: "临沂市" },
      { value: "德州市", level: "3", code: "3714", label: "德州市" },
      { value: "聊城市", level: "3", code: "3715", label: "聊城市" },
      { value: "滨州市", level: "3", code: "3716", label: "滨州市" },
      { value: "菏泽市", level: "3", code: "3717", label: "菏泽市" }
    ],
    label: "山东省"
  },
  {
    value: "河南省",
    level: "1",
    code: "4100",
    children: [
      { value: "郑州市", level: "2", code: "4101", label: "郑州市" },
      { value: "开封市", level: "3", code: "4102", label: "开封市" },
      { value: "洛阳市", level: "3", code: "4103", label: "洛阳市" },
      { value: "平顶山市", level: "3", code: "4104", label: "平顶山市" },
      { value: "安阳市", level: "3", code: "4105", label: "安阳市" },
      { value: "鹤壁市", level: "3", code: "4106", label: "鹤壁市" },
      { value: "新乡市", level: "3", code: "4107", label: "新乡市" },
      { value: "焦作市", level: "3", code: "4108", label: "焦作市" },
      { value: "濮阳市", level: "3", code: "4109", label: "濮阳市" },
      { value: "许昌市", level: "3", code: "4110", label: "许昌市" },
      { value: "漯河市", level: "3", code: "4111", label: "漯河市" },
      { value: "三门峡市", level: "3", code: "4112", label: "三门峡市" },
      { value: "南阳市", level: "3", code: "4113", label: "南阳市" },
      { value: "商丘市", level: "3", code: "4114", label: "商丘市" },
      { value: "信阳市", level: "3", code: "4115", label: "信阳市" },
      { value: "周口市", level: "3", code: "4116", label: "周口市" },
      { value: "驻马店市", level: "3", code: "4117", label: "驻马店市" }
    ],
    label: "河南省"
  },
  {
    value: "湖北省",
    level: "1",
    code: "4200",
    children: [
      { value: "武汉市", level: "2", code: "4201", label: "武汉市" },
      { value: "黄石市", level: "3", code: "4202", label: "黄石市" },
      { value: "十堰市", level: "3", code: "4203", label: "十堰市" },
      { value: "宜昌市", level: "3", code: "4205", label: "宜昌市" },
      { value: "襄樊市", level: "3", code: "4206", label: "襄樊市" },
      { value: "鄂州市", level: "3", code: "4207", label: "鄂州市" },
      { value: "荆门市", level: "3", code: "4208", label: "荆门市" },
      { value: "孝感市", level: "3", code: "4209", label: "孝感市" },
      { value: "荆州市", level: "3", code: "4210", label: "荆州市" },
      { value: "黄冈市", level: "3", code: "4211", label: "黄冈市" },
      { value: "咸宁市", level: "3", code: "4212", label: "咸宁市" },
      { value: "随州市", level: "3", code: "4213", label: "随州市" },
      {
        value: "恩施土家族苗族自治州",
        level: "3",
        code: "4228",
        label: "恩施土家族苗族自治州"
      }
    ],
    label: "湖北省"
  },
  {
    value: "湖南省",
    level: "1",
    code: "4300",
    children: [
      { value: "长沙市", level: "2", code: "4301", label: "长沙市" },
      { value: "株洲市", level: "3", code: "4302", label: "株洲市" },
      { value: "湘潭市", level: "3", code: "4303", label: "湘潭市" },
      { value: "衡阳市", level: "3", code: "4304", label: "衡阳市" },
      { value: "邵阳市", level: "3", code: "4305", label: "邵阳市" },
      { value: "岳阳市", level: "3", code: "4306", label: "岳阳市" },
      { value: "常德市", level: "3", code: "4307", label: "常德市" },
      { value: "张家界市", level: "3", code: "4308", label: "张家界市" },
      { value: "益阳市", level: "3", code: "4309", label: "益阳市" },
      { value: "郴州市", level: "3", code: "4310", label: "郴州市" },
      { value: "永州市", level: "3", code: "4311", label: "永州市" },
      { value: "怀化市", level: "3", code: "4312", label: "怀化市" },
      { value: "娄底市", level: "3", code: "4313", label: "娄底市" },
      {
        value: "湘西土家族苗族自治州",
        level: "3",
        code: "4331",
        label: "湘西土家族苗族自治州"
      }
    ],
    label: "湖南省"
  },
  {
    value: "广东省",
    level: "1",
    code: "4400",
    children: [
      { value: "广州市", level: "2", code: "4401", label: "广州市" },
      { value: "韶关市", level: "3", code: "4402", label: "韶关市" },
      { value: "深圳市", level: "3", code: "4403", label: "深圳市" },
      { value: "珠海市", level: "3", code: "4404", label: "珠海市" },
      { value: "汕头市", level: "3", code: "4405", label: "汕头市" },
      { value: "佛山市", level: "3", code: "4406", label: "佛山市" },
      { value: "江门市", level: "3", code: "4407", label: "江门市" },
      { value: "湛江市", level: "3", code: "4408", label: "湛江市" },
      { value: "茂名市", level: "3", code: "4409", label: "茂名市" },
      { value: "肇庆市", level: "3", code: "4412", label: "肇庆市" },
      { value: "惠州市", level: "3", code: "4413", label: "惠州市" },
      { value: "梅州市", level: "3", code: "4414", label: "梅州市" },
      { value: "汕尾市", level: "3", code: "4415", label: "汕尾市" },
      { value: "河源市", level: "3", code: "4416", label: "河源市" },
      { value: "阳江市", level: "3", code: "4417", label: "阳江市" },
      { value: "清远市", level: "3", code: "4418", label: "清远市" },
      { value: "东莞市", level: "3", code: "4419", label: "东莞市" },
      { value: "中山市", level: "3", code: "4420", label: "中山市" },
      { value: "潮州市", level: "3", code: "4451", label: "潮州市" },
      { value: "揭阳市", level: "3", code: "4452", label: "揭阳市" },
      { value: "云浮市", level: "3", code: "4453", label: "云浮市" }
    ],
    label: "广东省"
  },
  {
    value: "广西壮族自治区",
    level: "1",
    code: "4500",
    children: [
      { value: "南宁市", level: "2", code: "4501", label: "南宁市" },
      { value: "柳州市", level: "3", code: "4502", label: "柳州市" },
      { value: "桂林市", level: "3", code: "4503", label: "桂林市" },
      { value: "梧州市", level: "3", code: "4504", label: "梧州市" },
      { value: "北海市", level: "3", code: "4505", label: "北海市" },
      { value: "防城港市", level: "3", code: "4506", label: "防城港市" },
      { value: "钦州市", level: "3", code: "4507", label: "钦州市" },
      { value: "贵港市", level: "3", code: "4508", label: "贵港市" },
      { value: "玉林市", level: "3", code: "4509", label: "玉林市" },
      { value: "百色市", level: "3", code: "4510", label: "百色市" },
      { value: "贺州市", level: "3", code: "4511", label: "贺州市" },
      { value: "河池市", level: "3", code: "4512", label: "河池市" },
      { value: "来宾市", level: "3", code: "4513", label: "来宾市" },
      { value: "崇左市", level: "3", code: "4514", label: "崇左市" }
    ],
    label: "广西壮族自治区"
  },
  {
    value: "海南省",
    level: "1",
    code: "4600",
    children: [
      { value: "海口市", level: "2", code: "4601", label: "海口市" },
      { value: "三亚市", level: "3", code: "4602", label: "三亚市" }
    ],
    label: "海南省"
  },
  {
    value: "重庆市",
    level: "1",
    code: "5000",
    children: [{ value: "重庆市", level: "1", code: "5000", label: "重庆市" }],
    label: "重庆市"
  },
  {
    value: "四川省",
    level: "1",
    code: "5100",
    children: [
      { value: "成都市", level: "2", code: "5101", label: "成都市" },
      { value: "自贡市", level: "3", code: "5103", label: "自贡市" },
      { value: "攀枝花市", level: "3", code: "5104", label: "攀枝花市" },
      { value: "泸州市", level: "3", code: "5105", label: "泸州市" },
      { value: "德阳市", level: "3", code: "5106", label: "德阳市" },
      { value: "绵阳市", level: "3", code: "5107", label: "绵阳市" },
      { value: "广元市", level: "3", code: "5108", label: "广元市" },
      { value: "遂宁市", level: "3", code: "5109", label: "遂宁市" },
      { value: "内江市", level: "3", code: "5110", label: "内江市" },
      { value: "乐山市", level: "3", code: "5111", label: "乐山市" },
      { value: "南充市", level: "3", code: "5113", label: "南充市" },
      { value: "眉山市", level: "3", code: "5114", label: "眉山市" },
      { value: "宜宾市", level: "3", code: "5115", label: "宜宾市" },
      { value: "广安市", level: "3", code: "5116", label: "广安市" },
      { value: "达州市", level: "3", code: "5117", label: "达州市" },
      { value: "雅安市", level: "3", code: "5118", label: "雅安市" },
      { value: "巴中市", level: "3", code: "5119", label: "巴中市" },
      { value: "资阳市", level: "3", code: "5120", label: "资阳市" },
      {
        value: "阿坝藏族羌族自治州",
        level: "3",
        code: "5132",
        label: "阿坝藏族羌族自治州"
      },
      {
        value: "甘孜藏族自治州",
        level: "3",
        code: "5133",
        label: "甘孜藏族自治州"
      },
      {
        value: "凉山彝族自治州",
        level: "3",
        code: "5134",
        label: "凉山彝族自治州"
      }
    ],
    label: "四川省"
  },
  {
    value: "贵州省",
    level: "1",
    code: "5200",
    children: [
      { value: "贵阳市", level: "2", code: "5201", label: "贵阳市" },
      { value: "六盘水市", level: "3", code: "5202", label: "六盘水市" },
      { value: "遵义市", level: "3", code: "5203", label: "遵义市" },
      { value: "安顺市", level: "3", code: "5204", label: "安顺市" },
      { value: "铜仁地区", level: "3", code: "5222", label: "铜仁地区" },
      {
        value: "黔西南布依族苗族自治州",
        level: "3",
        code: "5223",
        label: "黔西南布依族苗族自治州"
      },
      { value: "毕节地区", level: "3", code: "5224", label: "毕节地区" },
      {
        value: "黔东南苗族侗族自治州",
        level: "3",
        code: "5226",
        label: "黔东南苗族侗族自治州"
      },
      {
        value: "黔南布依族苗族自治州",
        level: "3",
        code: "5227",
        label: "黔南布依族苗族自治州"
      }
    ],
    label: "贵州省"
  },
  {
    value: "云南省",
    level: "1",
    code: "5300",
    children: [
      { value: "昆明市", level: "2", code: "5301", label: "昆明市" },
      { value: "曲靖市", level: "3", code: "5303", label: "曲靖市" },
      { value: "玉溪市", level: "3", code: "5304", label: "玉溪市" },
      { value: "保山市", level: "3", code: "5305", label: "保山市" },
      { value: "昭通市", level: "3", code: "5306", label: "昭通市" },
      { value: "丽江市", level: "3", code: "5307", label: "丽江市" },
      { value: "普洱市", level: "3", code: "5308", label: "普洱市" },
      { value: "临沧市", level: "3", code: "5309", label: "临沧市" },
      {
        value: "楚雄彝族自治州",
        level: "3",
        code: "5323",
        label: "楚雄彝族自治州"
      },
      {
        value: "红河哈尼族彝族自治州",
        level: "3",
        code: "5325",
        label: "红河哈尼族彝族自治州"
      },
      {
        value: "文山壮族苗族自治州",
        level: "3",
        code: "5326",
        label: "文山壮族苗族自治州"
      },
      {
        value: "西双版纳傣族自治州",
        level: "3",
        code: "5328",
        label: "西双版纳傣族自治州"
      },
      {
        value: "大理白族自治州",
        level: "3",
        code: "5329",
        label: "大理白族自治州"
      },
      {
        value: "德宏傣族景颇族自治州",
        level: "3",
        code: "5331",
        label: "德宏傣族景颇族自治州"
      },
      {
        value: "怒江傈僳族自治州",
        level: "3",
        code: "5333",
        label: "怒江傈僳族自治州"
      },
      {
        value: "迪庆藏族自治州",
        level: "3",
        code: "5334",
        label: "迪庆藏族自治州"
      }
    ],
    label: "云南省"
  },
  {
    value: "西藏自治区",
    level: "1",
    code: "5400",
    children: [
      { value: "拉萨市", level: "2", code: "5401", label: "拉萨市" },
      { value: "昌都地区", level: "3", code: "5421", label: "昌都地区" },
      { value: "山南地区", level: "3", code: "5422", label: "山南地区" },
      { value: "日喀则地区", level: "3", code: "5423", label: "日喀则地区" },
      { value: "那曲地区", level: "3", code: "5424", label: "那曲地区" },
      { value: "阿里地区", level: "3", code: "5425", label: "阿里地区" },
      { value: "林芝地区", level: "3", code: "5426", label: "林芝地区" }
    ],
    label: "西藏自治区"
  },
  {
    value: "陕西省",
    level: "1",
    code: "6100",
    children: [
      { value: "西安市", level: "2", code: "6101", label: "西安市" },
      { value: "铜川市", level: "3", code: "6102", label: "铜川市" },
      { value: "宝鸡市", level: "3", code: "6103", label: "宝鸡市" },
      { value: "咸阳市", level: "3", code: "6104", label: "咸阳市" },
      { value: "渭南市", level: "3", code: "6105", label: "渭南市" },
      { value: "延安市", level: "3", code: "6106", label: "延安市" },
      { value: "汉中市", level: "3", code: "6107", label: "汉中市" },
      { value: "榆林市", level: "3", code: "6108", label: "榆林市" },
      { value: "安康市", level: "3", code: "6109", label: "安康市" },
      { value: "商洛市", level: "3", code: "6110", label: "商洛市" }
    ],
    label: "陕西省"
  },
  {
    value: "甘肃省",
    level: "1",
    code: "6200",
    children: [
      { value: "兰州市", level: "2", code: "6201", label: "兰州市" },
      { value: "嘉峪关市", level: "3", code: "6202", label: "嘉峪关市" },
      { value: "金昌市", level: "3", code: "6203", label: "金昌市" },
      { value: "白银市", level: "3", code: "6204", label: "白银市" },
      { value: "天水市", level: "3", code: "6205", label: "天水市" },
      { value: "武威市", level: "3", code: "6206", label: "武威市" },
      { value: "张掖市", level: "3", code: "6207", label: "张掖市" },
      { value: "平凉市", level: "3", code: "6208", label: "平凉市" },
      { value: "酒泉市", level: "3", code: "6209", label: "酒泉市" },
      { value: "庆阳市", level: "3", code: "6210", label: "庆阳市" },
      { value: "定西市", level: "3", code: "6211", label: "定西市" },
      { value: "陇南市", level: "3", code: "6212", label: "陇南市" },
      {
        value: "临夏回族自治州",
        level: "3",
        code: "6229",
        label: "临夏回族自治州"
      },
      {
        value: "甘南藏族自治州",
        level: "3",
        code: "6230",
        label: "甘南藏族自治州"
      }
    ],
    label: "甘肃省"
  },
  {
    value: "青海省",
    level: "1",
    code: "6300",
    children: [
      { value: "西宁市", level: "2", code: "6301", label: "西宁市" },
      { value: "海东地区", level: "3", code: "6321", label: "海东地区" },
      {
        value: "海北藏族自治州",
        level: "3",
        code: "6322",
        label: "海北藏族自治州"
      },
      {
        value: "黄南藏族自治州",
        level: "3",
        code: "6323",
        label: "黄南藏族自治州"
      },
      {
        value: "海南藏族自治州",
        level: "3",
        code: "6325",
        label: "海南藏族自治州"
      },
      {
        value: "果洛藏族自治州",
        level: "3",
        code: "6326",
        label: "果洛藏族自治州"
      },
      {
        value: "玉树藏族自治州",
        level: "3",
        code: "6327",
        label: "玉树藏族自治州"
      },
      {
        value: "海西蒙古族藏族自治州",
        level: "3",
        code: "6328",
        label: "海西蒙古族藏族自治州"
      }
    ],
    label: "青海省"
  },
  {
    value: "宁夏回族自治区",
    level: "1",
    code: "6400",
    children: [
      { value: "银川市", level: "2", code: "6401", label: "银川市" },
      { value: "石嘴山市", level: "3", code: "6402", label: "石嘴山市" },
      { value: "吴忠市", level: "3", code: "6403", label: "吴忠市" },
      { value: "固原市", level: "3", code: "6404", label: "固原市" },
      { value: "中卫市", level: "3", code: "6405", label: "中卫市" }
    ],
    label: "宁夏回族自治区"
  },
  {
    value: "新疆维吾尔自治区",
    level: "1",
    code: "6500",
    children: [
      { value: "乌鲁木齐市", level: "2", code: "6501", label: "乌鲁木齐市" },
      { value: "克拉玛依市", level: "3", code: "6502", label: "克拉玛依市" },
      { value: "吐鲁番地区", level: "3", code: "6521", label: "吐鲁番地区" },
      { value: "哈密地区", level: "3", code: "6522", label: "哈密地区" },
      {
        value: "昌吉回族自治州",
        level: "3",
        code: "6523",
        label: "昌吉回族自治州"
      },
      {
        value: "博尔塔拉蒙古自治州",
        level: "3",
        code: "6527",
        label: "博尔塔拉蒙古自治州"
      },
      {
        value: "巴音郭楞蒙古自治州",
        level: "3",
        code: "6528",
        label: "巴音郭楞蒙古自治州"
      },
      { value: "阿克苏地区", level: "3", code: "6529", label: "阿克苏地区" },
      {
        value: "克孜勒苏柯尔克孜自治州",
        level: "3",
        code: "6530",
        label: "克孜勒苏柯尔克孜自治州"
      },
      { value: "喀什地区", level: "3", code: "6531", label: "喀什地区" },
      { value: "和田地区", level: "3", code: "6532", label: "和田地区" },
      {
        value: "伊犁哈萨克自治州",
        level: "3",
        code: "6540",
        label: "伊犁哈萨克自治州"
      },
      { value: "塔城地区", level: "3", code: "6542", label: "塔城地区" },
      { value: "阿勒泰地区", level: "3", code: "6543", label: "阿勒泰地区" }
    ],
    label: "新疆维吾尔自治区"
  },
  {
    value: "台湾省",
    level: "1",
    code: "7100",
    children: [{ value: "台湾省", level: "1", code: "7100", label: "台湾省" }],
    label: "台湾省"
  },
  {
    value: "香港特别行政区",
    level: "1",
    code: "8100",
    children: [
      {
        value: "香港特别行政区",
        level: "1",
        code: "8100",
        label: "香港特别行政区"
      }
    ],
    label: "香港特别行政区"
  },
  {
    value: "澳门特别行政区",
    level: "1",
    code: "8200",
    children: [
      {
        value: "澳门特别行政区",
        level: "1",
        code: "8200",
        label: "澳门特别行政区"
      }
    ],
    label: "澳门特别行政区"
  }
];

/* 

import JobCard from "components/jobCard";
import Introduction from "components/introduction"
import DetailTabNav from "components/detailTabNav"
import TextHeader from "components/textHeader";
import BannerSwiper from "components/bannerSwiper";
import LoginBox from "components/LoginBox";

import CompanyInfoCard from "components/company/detail/companyDetailInfo"

//home
import Nums from "components/home/nums";
import LoginBtns from "components/home/loginBtns";
import NewsCard from "components/newsCard";
import LongNews from "components/home/longNews";
import SquareSwiper from "components/squareSwiperBanner";
import LongAdvertising from "components/longAdvertising";


import ActivityFilter from "components/activity/activityFilter"
import ActivityListWrapper from "components/activity/activityListWrapper";

import JobsFilter from "components/jobs/jobsFilter"
import JobListWrapper from "components/jobs/jobListWrapper";

import CompanyFilter from "components/company/companyFilter"
import CompanyListWrapper from "components/company/companyListWrapper"

import InformationFilter from "components/information/informationFilter"
import InformationListWrapper from "components/information/informationListWrapper"

import CompanyCard from "components/companyCard";

import {} from "constants/publicData"
import {} from "constants/routerLink"
*/